import { render, staticRenderFns } from "./CardNoticiaAprovada.vue?vue&type=template&id=fe72fd4c"
import script from "./CardNoticiaAprovada.vue?vue&type=script&lang=js"
export * from "./CardNoticiaAprovada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports